import { Alert, Snackbar } from '@mui/material';
import { useGlobalContext } from '@/store';

export function Toast() {
  const { toast, closeToast } = useGlobalContext();

  return (
    <Snackbar open={toast.show} autoHideDuration={6000} onClose={closeToast} anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}>
      <Alert onClose={closeToast} severity={toast.type} sx={{ width: '100%' }}>
        {toast.message}
      </Alert>
    </Snackbar>
  );
}
